var widgetFeeds = [
    {
      type: "news",
      text: "News généralistes",
      name: "News-addict Actualités",
      url: "https://www.news-addict.com/fr/5e710ca73a406320885498d9/rss",
      icon: "https://cdn.mashup-web.com/img/header/logo-news.png",
      color: "#182436"
    },
    {
      type: "football",
      text: "Ligue 1",
      name: "Football-addict Ligue 1",
      url: "https://www.football-addict.com/fr/55b69b1684a97539138b457d/rss",
      icon: "https://cdn.mashup-web.com/img/header/logo-football.png",
      color: "#388e3c"
    },
    {
      type: "motors",
      text: "Moto GP",
      name: "Motors-addict Moto GP",
      url: "https://www.motors-addict.com/fr/58a31a5ecac90d320e183801/rss",
      icon: "https://cdn.mashup-web.com/img/header/logo-motors.png",
      color: "#c51b12"
    },
    {
      type: "sports",
      text: "Cyclisme",
      name: "Sports-addict Cyclisme",
      url: "https://www.sports-addict.net/fr/5b1929b4a923ff0b513b7d92/rss",
      icon: "https://cdn.mashup-web.com/img/header/logo-sports.png",
      color: "#141D4A"
    },
    {
      type: "gossip",
      text: "Plus Belle La Vie",
      name: "Gossip-addict Plus Belle La Vie",
      url: "https://www.gossip-addict.com/fr/5b4c78aca923ff365e48f7f4/rss",
      icon: "https://cdn.mashup-web.com/img/header/logo-gossip.png",
      color: "#302f2f"
    }
]

export default widgetFeeds
